/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function AccessControl({ allowedRoles = [], redirectTo = "/404" }) {
  const navigate = useNavigate();

  useEffect(() => {
    const adminData = localStorage.getItem("admin");
    const userData = adminData ? JSON.parse(adminData) : null;

    // Not logged in — redirect to 404
    if (!userData) {
      navigate("/404", { replace: true });
      return;
    }

    // Role not allowed — redirect to /unauthorized (shows "Access Denied" screen)
    if (allowedRoles.length > 0 && !allowedRoles.includes(userData.role)) {
      navigate("/unauthorized", {
        replace: true,
        state: { role: userData.role },
      });
      return;
    }
  }, []);

  return null;
}

export default AccessControl;
